module.exports = __webpack_public_path__ + "img/hero.4c3dd515.jpg";